/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerOutputSettings.yaml
import { DocumentStraighteningParameters } from '../../document_scanner/DocumentEnhancerTypes';
import { ParametricFilter } from '../../image_processing/ParametricFilters';
/** @hidden */
export const DocumentAnalysisModeValues = [
    'FILTERED_DOCUMENT',
    'UNFILTERED_DOCUMENT',
];
/**
Configuration of the output settings.
*/
export class DocumentScannerOutputSettings {
    /** @param source {@displayType `DeepPartial<DocumentScannerOutputSettings>`} */
    constructor(source = {}) {
        /**
          The limit of the number of pages that can be scanned. Default is 0 (no limit).
          
          Default is 0
          */
        this.pagesScanLimit = 0;
        /**
          The limit of the size of the cropped document images. If one of the dimensions of the cropped image is larger than the limit, the image is downscaled so that its longer dimension matches the limit. The default is 0 (no limit).
          
          Default is 0
          */
        this.documentImageSizeLimit = 0;
        /**
          Determines if the quality analysis for the acknowledgement mode will run on the filtered or the unfiltered image.
          
          Default is UNFILTERED_DOCUMENT
          */
        this.documentAnalysisMode = 'UNFILTERED_DOCUMENT';
        /**
          Determines the image filter to apply by default.
          */
        this.defaultFilter = null;
        /**
          Configuration of the document straightening (document geometry correction/dewarping) parameters that will be applied for pages of the document.
          */
        this.straighteningParameters = new DocumentStraighteningParameters({});
        if (source.pagesScanLimit !== undefined) {
            this.pagesScanLimit = source.pagesScanLimit;
        }
        if (source.documentImageSizeLimit !== undefined) {
            this.documentImageSizeLimit = source.documentImageSizeLimit;
        }
        if (source.documentAnalysisMode !== undefined) {
            this.documentAnalysisMode = source.documentAnalysisMode;
        }
        if (source.defaultFilter !== undefined) {
            this.defaultFilter = source.defaultFilter != null ? ParametricFilter.from(source.defaultFilter) : null;
        }
        if (source.straighteningParameters !== undefined) {
            this.straighteningParameters = new DocumentStraighteningParameters(source.straighteningParameters);
        }
    }
}
//# sourceMappingURL=DocumentScannerOutputSettings.js.map